import moment from 'moment'

var functions = {
  capitalize(str) {
    if (str.length > 1) {
      return str[0].toUpperCase() + str.substr(1)
    } else if (str.length > 0) {
      return str[0].toUpperCase()
    } else {
      return str
    }
  },
  capitalizeWords(string) {
    return string.split(' ').map(word => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');
  },
  truncateString(str, len = 140) {
    if (str && str.length > len) {
      return str.slice(0, len) + '...'
    }
    return str
  },
  formatTimeAgo(timeStr) {
    return moment(new Date(timeStr)).fromNow()
  },
  shortStandardRefFromLongRef(longRef, setCode) {
    if (setCode === 'CCSS') {
      return longRef.indexOf('Math.Content') >= 0
        ? longRef
            .split('.')
            .slice(3)
            .join('.')
        : longRef
            .split('.')
            .slice(2)
            .join('.')
    } else if (setCode === 'TEKS' || setCode === 'TEKS-2017') {
      return longRef
        .split('.')
        .slice(1)
        .join('.')
    } else if (setCode === 'NCSCoS') {
      return longRef.slice(3)
    }
    return ''
  },
  standardRefsForSetCode(setCode, standards) {
    if (!standards || !Array.isArray(standards)) {
      return []
    }
    return standards
      .filter(standard => {
        return standard.standard_set_code === setCode
      })
      .map(standard => {
        return standard.standard_long_ref
      })
  }
}

export default functions
